export type WalletType = 'rabby' | 'metamask' | 'coinbase';

/**
 * @description check if user installed specific wallet(maybe not active)
 */
export function isUserInstalledWallet(type: WalletType = 'rabby') {
  switch (type) {
    case 'coinbase':
      return !!window.coinbaseWalletExtension;
    default: // metamask like
      return !!window.ethereum;
  }
}

export function maybeWalletProviderFrom(type: WalletType | 'coinbase-browser') {
  switch (type) {
    case 'rabby':
      return window.ethereum?.isRabby && window.ethereum?.isMetaMask;
    case 'metamask':
      return !window.ethereum?.isRabby && window.ethereum?.isMetaMask;
    case 'coinbase':
      return !!window.ethereum?.isCoinbaseWallet;
    case 'coinbase-browser':
      return !!window.ethereum?.isCoinbaseWallet;
    default:
      throw new Error(`[maybeWalletProviderFrom] unsupported wallet type ${type}`);
  }
}
